import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ComparisonTable() {
  const rows = [{
    feature: 'On-site assessment before recommendation',
    langler: true,
    wholesaler: false,
    discount: false
  }, {
    feature: 'Fixed price in writing, no surprises',
    langler: true,
    wholesaler: false,
    discount: false
  }, {
    feature: 'Mitsubishi Diamond Dealer accredited',
    langler: true,
    wholesaler: false,
    discount: false
  }, {
    feature: 'Same family, same workshop, 30+ years',
    langler: true,
    wholesaler: false,
    discount: false
  }, {
    feature: 'Lifetime workmanship guarantee',
    langler: true,
    wholesaler: false,
    discount: false
  }, {
    feature: 'Clean install promise (drop sheets, vacuum)',
    langler: true,
    wholesaler: false,
    discount: false
  }, {
    feature: 'Same business day callback',
    langler: true,
    wholesaler: false,
    discount: false
  }, {
    feature: 'Picks up the phone after install',
    langler: true,
    wholesaler: false,
    discount: false
  }];
  return <section className="bg-cream py-20 md:py-28" data-id="element-90" data-mp="2nx67fc3lul6g">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91" data-mp="2iwry7qq9p56u">
        <div className="max-w-3xl mb-12" data-id="element-92" data-mp="2iyl77cocs1i0">
          <div className="kicker mb-3" data-id="element-93" data-mp="2wvrlov21ne1f">Compare honestly</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-ink-900 tracking-tight leading-tight" data-id="element-94" data-mp="2wu6w7jul6laf">
            Langler Air vs the other guys.
          </h2>
          <p className="mt-4 text-lg text-stone-600" data-id="element-95" data-mp="36lb5q41htdxv">
            Fair question. Honest answer.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-2xl border border-stone-200 overflow-hidden shadow-lg" data-id="element-96" data-mp="3gka7d2nuc9bd">
          <div className="overflow-x-auto" data-id="element-97" data-mp="3smjx5iigd7uv">
            <div className="min-w-[600px]" data-id="element-98" data-mp="3slrzm25ap01y">
              {/* Header row */}
              <div className="grid grid-cols-[2fr_1fr_1fr_1fr] sticky left-0" data-id="element-99" data-mp="185qbdu20v18">
                <div className="p-5" data-id="element-100" data-mp="678wj1lrt7as"></div>
                <div className="p-5 bg-brand text-white text-center" data-id="element-101" data-mp="6679rzve6wd8">
                  <div className="text-[10px] uppercase tracking-wider font-bold opacity-80 mb-1" data-id="element-102" data-mp="a8147qezv44y">
                    Us
                  </div>
                  <div className="font-display text-base font-extrabold" data-id="element-103" data-mp="f8ggsfrgc7lv">
                    Langler Air
                  </div>
                </div>
                <div className="p-5 text-center border-l border-stone-200" data-id="element-104" data-mp="2gzjy1nvukkfe">
                  <div className="text-[10px] uppercase tracking-wider font-bold text-stone-500 mb-1" data-id="element-105" data-mp="2ly3krqi9m08t">
                    Them
                  </div>
                  <div className="font-display text-base font-extrabold text-stone-700" data-id="element-106" data-mp="2efdp11sdm3rz">
                    Wholesalers
                  </div>
                </div>
                <div className="p-5 text-center border-l border-stone-200" data-id="element-107" data-mp="24o9dyd5tn32f">
                  <div className="text-[10px] uppercase tracking-wider font-bold text-stone-500 mb-1" data-id="element-108" data-mp="1zppr8ajeln90">
                    Them
                  </div>
                  <div className="font-display text-base font-extrabold text-stone-700" data-id="element-109" data-mp="2xc59vfnkgqy5">
                    Discount Installers
                  </div>
                </div>
              </div>

              {rows.map((row, i) => <div key={i} className="grid grid-cols-[2fr_1fr_1fr_1fr] border-t border-stone-200 hover:bg-cream-100 transition-colors" data-id="element-110" data-mp="2nh3hmaxzv8rc" data-mpi={i}>
                  <div className="p-4 text-sm font-medium text-ink-900" data-id="element-111" data-mp="1by0socfzo2jm">
                    {row.feature}
                  </div>
                  <div className="p-4 flex items-center justify-center bg-brand/5" data-id="element-112" data-mp="2vvho1gigrccu">
                    <Check size={20} className="text-brand" strokeWidth={3} data-id="element-113" data-mp="30ly12zidgvyo" />
                  </div>
                  <div className="p-4 flex items-center justify-center border-l border-stone-200" data-id="element-114" data-mp="2lx1yvj2zyd5z">
                    <X size={20} className="text-stone-400" strokeWidth={2.5} data-id="element-115" data-mp="2qw4te9lcp0zp" />
                  </div>
                  <div className="p-4 flex items-center justify-center border-l border-stone-200" data-id="element-116" data-mp="3elz2qh6go7f7">
                    <X size={20} className="text-stone-400" strokeWidth={2.5} data-id="element-117" data-mp="3jkiqmn4m7ta7" />
                  </div>
                </div>)}
            </div>
          </div>
        </motion.div>

        <p className="mt-6 text-sm text-stone-500 max-w-3xl" data-id="element-118" data-mp="39mmf3u7rmwbk">
          We're not always the cheapest on the unit. We are, almost always, the
          cheapest over 10 years, because right-sized systems run less and last
          longer.
        </p>
      </div>
    </section>;
}